import React, { useState } from 'react'
import { Table } from 'antd'

import { buildTableColumns } from './market-index-table-columns'
import { MarketIndexTableItem } from '../models'
import { MarketIndexModalDelete } from '../MarketIndexDelete'
import { MarketIndexUpdateDrawer } from '../MarketIndexUpdate'

interface Props {
  isLoading: boolean
  marketIndexes: MarketIndexTableItem[]
  fetchMarketIndexes: () => void
}

export const MarketIndexesList = ({ isLoading, marketIndexes, fetchMarketIndexes }: Props) => {
  const [marketIndexToDelete, setMarketIndexToDelete] = useState(null)
  const [marketIndexToUpdate, setMarketIndexToUpdate] = useState(null)

  const onDelete = (marketIndex) => {
    setMarketIndexToDelete(marketIndex)
  }

  const onUpdate = (marketIndex) => {
    setMarketIndexToUpdate(marketIndex)
  }

  const onSuccess = () => {
    fetchMarketIndexes()
    setMarketIndexToDelete(null)
    setMarketIndexToUpdate(false)
  }

  const columns = buildTableColumns({ onDelete, onUpdate })

  return (
    <>
      <Table
        columns={columns}
        dataSource={marketIndexes}
        loading={isLoading}
        rowKey="id"
        pagination={{ pageSize: 100 }}
        size="small"
      />
      <MarketIndexModalDelete
        marketIndex={marketIndexToDelete}
        isVisible={!!marketIndexToDelete}
        onClose={() => setMarketIndexToDelete(null)}
        onSuccess={onSuccess}
      />
      <MarketIndexUpdateDrawer
        marketIndex={marketIndexToUpdate}
        isVisible={!!marketIndexToUpdate}
        onClose={() => setMarketIndexToUpdate(false)}
        onSuccess={onSuccess}
      />
    </>
  )
}
